import { useLocation } from 'react-router-dom';
import { useChat } from '../../contexts/ChatContext';
import { useUserStore } from '../../stores/userStore';
import AssistantLauncher from '../Assistant/AssistantLauncher';
import ChatPanel from './ChatPanel';

/**
 * The single chat entry point: a floating button that opens one panel holding
 * the AI assistant and every conversation (tenants, agents, SMS, WhatsApp).
 * The user-menu item opens the same panel via ChatContext.openChat.
 */
export const FloatingChat: React.FC = () => {
  const { isChatOpen, openChat, unreadCount } = useChat();
  const isSignedIn = useUserStore((s) => Boolean(s.token && s.currentUser));
  const { pathname } = useLocation();

  if (isChatOpen) return <ChatPanel />;
  if (!isSignedIn || pathname.startsWith('/auth')) return null;
  return <AssistantLauncher unread={unreadCount} onOpen={() => openChat('assistant')} />;
};

export default FloatingChat;
